<div *ngIf="taskId === undefined && messageId === undefined && (assessmentTaskId === null || assessmentTaskId === undefined) && !viewerOnly">
  <kendo-grid [data]="view.gridData" [loading]="view.loading"
    [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="view.state.take"
    [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort" [filterable]="enableAdvanced"
    [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups" [selectable]="{ mode: 'single' }"
    [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
    (dataStateChange)="dataStateChange($event)">
    <kendo-grid-messages noRecords="{{'NO-DOCUMENTS' | translate}}">
    </kendo-grid-messages>
    <kendo-grid-column *ngIf="showTaskColumn" field="taskName" [width]="20" title="{{ 'TASK' | translate }}"></kendo-grid-column>
    <kendo-grid-column field="description" [width]="40" title="{{ 'NAME' | translate }}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <i class="fas fa-file fa-lg mr-1" class="fa {{getFileTypeClass(dataItem.mediaType)}}"
          title="{{dataItem.description}}"></i><span title="{{dataItem.description}}">{{dataItem.description}}</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="mediaType" [width]="20" title="{{ 'DOCUMENT-TYPE' | translate }}"></kendo-grid-column>
    <kendo-grid-column field="date" [width]="22" title="{{ 'DATE' | translate }}" filter="date" format="{0:d}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngIf="dataItem.date!==null">{{ intl.formatDate(intl.parseDate(dataItem.date), "g") }}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="documentCategory" [width]="20" title="{{ 'CATEGORY' | translate }}"
      *ngIf="showDocumentCategory">
    </kendo-grid-column>
    <kendo-grid-column field="organizationName" [width]="40" title="{{ 'SOURCE-ORGANIZATION' | translate }}"
      *ngIf="showDocumentOrganization">
    </kendo-grid-column>
    <kendo-grid-command-column [width]="18" title="{{ 'ACTIONS' | translate }}" class="text-center p-0">
      <ng-template kendoGridCellTemplate let-dataItem>
        <i *ngIf="dataItem.url" class="fas fa-download fa-lg" title="{{ 'DOWNLOAD' | translate }}"
          (click)="saveFileLocal(dataItem['url'], dataItem['description'], dataItem['isDownloadDisabled'])"
          role="button" attr.aria-label="{{ 'DOWNLOAD' | translate }}" tabindex="0"
          (keydown.enter)="saveFileLocal(dataItem['url'], dataItem['description'], dataItem['isDownloadDisabled'])"
          (keydown.space)="saveFileLocal(dataItem['url'], dataItem['description'], dataItem['isDownloadDisabled'])">
        </i>
        &nbsp;
        <i *ngIf="dataItem.url" class="fas fa-eye fa-lg" title="{{ 'VIEW' | translate }}"
          (click)="viewHandler(dataItem['url'], dataItem['description'], dataItem['mediaType'], dataItem['date'])"
          role="button" attr.aria-label="{{ 'VIEW' | translate }}" tabindex="0"
          (keydown.enter)="viewHandler(dataItem['url'], dataItem['description'], dataItem['mediaType'], dataItem['date'])"
          (keydown.space)="viewHandler(dataItem['url'], dataItem['description'], dataItem['mediaType'], dataItem['date'])">
        </i>
        &nbsp;
        <i *ngIf="dataItem.url && allowDelete" class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
          (click)="setDocumentToDelete(dataItem['url'], dataItem['description'])" role="button"
          attr.aria-label="{{ 'DELETE' | translate }}" tabindex="0"
          (keydown.enter)="setDocumentToDelete(dataItem['url'], dataItem['description'])"
          (keydown.space)="setDocumentToDelete(dataItem['url'], dataItem['description'])">
        </i>
        &nbsp;
        <i *ngIf="dataItem.url" class="fas fa-envelope fa-send-document-action fa-lg"
          title="{{ 'SEND-DOCUMENT' | translate }}"
          (click)="onSendDocument(dataItem.url, dataItem.description, dataItem.isDownloadDisabled)" role="button"
          attr.aria-label="{{ 'SEND-DOCUMENT' | translate }}" tabindex="0"
          (keydown.enter)="onSendDocument(dataItem.url, dataItem.description, dataItem.isDownloadDisabled)"
          (keydown.space)="onSendDocument(dataItem.url, dataItem.description, dataItem.isDownloadDisabled)">
        </i>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
</div>

<div
  *ngIf="taskId !== undefined || messageId !== undefined || (assessmentTaskId !== null && assessmentTaskId !== undefined)">
  <span *ngIf="data.length === 0 && ((assessmentTaskId === undefined) || (assessmentTaskId !== 0))"
    style="color: rgba(0, 0, 0, 0.25);">{{'NO-DOCUMENTS' | translate}}</span>
  <div class="row" *ngFor="let d of data">
    <div class="col-7 ellipsis-text">
      <i class="fas fa-file fa-lg mr-1" class="fa {{getFileTypeClass(d.mediaType)}}" title="{{d.description}}"></i>
      <span title="{{d.description}}">{{d.description}}</span>
    </div>
    <div class="col-5 text-right">
      <i *ngIf="d?.url" class="fas fa-download fa-lg" title="{{ 'DOWNLOAD' | translate }}"
        (click)="saveFileLocal(d['url'], d['description'], d['isDownloadDisabled'])" tabindex="0"
        (keydown.enter)="saveFileLocal(d['url'], d['description'], d['isDownloadDisabled'])"
        (keydown.space)="saveFileLocal(d['url'], d['description'], d['isDownloadDisabled'])">
      </i>
      &nbsp;
      <i *ngIf="d?.url" class="fas fa-eye fa-lg"
        [ngClass]="{'extra-padding': !((d.taskId === undefined) || (taskId === undefined && d.taskId === null) || (d.assessmentTaskId === 0 || d.assessmentTaskId === null || d.assessmentTaskId === undefined))}"
        title="{{ 'VIEW' | translate }}" (click)="viewHandler(d['url'], d['description'], d['mediaType'], d['date'])"
        tabindex="0" (keydown.enter)="viewHandler(d['url'], d['description'], d['mediaType'], d['date'])"
        (keydown.space)="viewHandler(d['url'], d['description'], d['mediaType'], d['date'])">
      </i>
      <span *ngIf="d?.url && messageId === undefined">
        &nbsp;
        <i *ngIf="(d.taskId === undefined) || (taskId === undefined && d.taskId === null) || (d.assessmentTaskId === 0 || d.assessmentTaskId === null || d.assessmentTaskId === undefined)"
          class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
          (click)="setDocumentToDelete(d['url'], d['description'])" tabindex="0"
          (keydown.enter)="setDocumentToDelete(d['url'], d['description'])"
          (keydown.space)="setDocumentToDelete(d['url'], d['description'])">
        </i>
        &nbsp;
        <i *ngIf="d.url && allowEmail" class="fas fa-envelope fa-send-document-action fa-lg mr-1"
          title="{{ 'SEND-DOCUMENT' | translate }}" (click)="onSendDocument(d.url, d.description)" tabindex="0"
          (keydown.enter)="onSendDocument(d.url, d.description)" (keydown.space)="onSendDocument(d.url, d.description)">
        </i>
      </span>
    </div>
  </div>
</div>

<input class="d-none" type="file" (change)="onFileChanged($event)" #fileInput>
<button *ngIf="allowAdd && !viewerOnly && ((assessmentTaskId === undefined) || (assessmentTaskId !== 0) || ((assessmentTaskId === 0 && taskId !== undefined)))" kendoButton [primary]="true" type="button" (click)="fileInput.click()"
  class="mt-3 mb-2 mr-1 float-right">
  {{'ADD-DOCUMENT' | translate}}<i class="far fa-plus"></i>
</button>
<button *ngIf="allowSendCaptureLink && !viewerOnly" kendoButton [primary]="true" type="button"
  (click)="sendCaptureLink()" class="mt-3 mb-2 mr-2 float-right">
  {{'SEND-CAPTURE-LINK' | translate}}<i class="far fa-external-link"></i>
</button>
<button *ngIf="allowSendConsentLink && !viewerOnly" kendoButton [primary]="true" type="button"
  (click)="sendConsentLink()" class="mt-3 mb-2 mr-2 float-right">
  {{'SEND-REQUEST-CONSENT-LINK' | translate}}<i class="far fa-external-link"></i>
</button>

<!--Note deletion confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteConfirmationOpened"
  (close)="deleteConfirmationOpened=false" [minWidth]="250" [width]="500">
  <div class="pl-3 pr-3 pt-3">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{documentToDeleteName}}</span>
    <form [formGroup]="deleteForm">
      <div class="row">
        <div class="col-12 mt-2">
          <label>
            <span class="k-text-uppercase dark">
              {{'REASON-FOR-DELETION' | translate}}
            </span>
            <textarea kendoTextArea [autoSize]="true" rows="3" formControlName="reasonForDeletion" class="w-100"
              maxlength="150" style="max-height: 200px">
            </textarea>
          </label>
        </div>
      </div>
    </form>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="cancelDelete()">{{ 'NO' | translate }}</button>
    <button kendoButton (click)="deleteDocument()" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<app-send-document [memberId]="memberId" [caseId]="caseId" [documentUrl]="documentUrl" [documentName]="documentName"
  #sendEmail>
</app-send-document>

<app-document-viewer #documentViewer></app-document-viewer>
<app-document-link-selection [memberId]="memberId" [member]="member" [consentMemberId]="memberConsentId"
  [consentLinkMode]="consentLinkMode" [taskId]="taskId" [caseId]="caseId" [open]="sendLinkDialogOpened"
  (closing)="closingLinkDialog()">
</app-document-link-selection>
